// API
import BaseApi from './base';

class ConstitucionSociedadesApi extends BaseApi {
  constructor() {
    super('constitucionSociedades');
  }

  sendLinkPagoComplementario(params = {}) {
    return this.request.post(`/constitucionSociedades/pago_complementario`, {
        ...params
    });
  }
}

export default new ConstitucionSociedadesApi();
